/*global PubReader*/

import 'url-search-params-polyfill';
import 'classlist-polyfill';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import './helpers/polyfills/array.from.js';

import React from 'react';
import ReactDOM from 'react-dom';
import Main from './modules/reader/components/MainContainer';
import Overlay from './components/Overlay';
import { Provider } from 'react-redux';
import store from './modules/store';
import { fetchPub, hideTableOfContents, receivedPub, receivePub, initClientSide } from './modules/reader/readerActions';

import './styles/normalize.css';
import './styles/common.css';
import './styles/simple-scrollbar.css';

import './helpers/outline.js';


window.PubReader = class PubReader {
    constructor({ apiUrl, selector, preloadedPub}) {
        this.apiUrl = apiUrl;
        this.readButtonSelector = selector;
        this.preloadedPub = preloadedPub;
        var container = document.getElementById('app');
        if(!container) {
            this.createContainer();
        }
        else {
            this.container = container;
            this.hydrate();
        }
        this.initReadButtons(selector);

        //window.addEventListener('popstate', (e) => {
        //    var params = new URLSearchParams(window.location.search);
        //    var pubId = params.get('pub');
        //    if(pubId) {
        //        this.open(pubId, false);
        //        window.history.replaceState(null, null, "?" + params.toString());
        //    }
        //    else {
        //        this.close();
        //    }
        //});
        document.addEventListener('pub-closing', (e) => {
            this.close();
            store.dispatch(hideTableOfContents());
            document.body.classList.remove('pubr-toc-expanded');
            document.body.classList.remove('pubr-sticky');
            let params = new URLSearchParams(window.location.search);
            params.delete('pub');
            window.history.replaceState(null, null, "?" + params.toString());
        });
    }
    createContainer() {
        var container = document.createElement('div');
        container.setAttribute('id', 'app');
        document.body.insertAdjacentElement('afterbegin', container);
        this.container = container;
    }
    initReadButtons(selector) {
        var readButtons = document.querySelectorAll('.publication-open');
        for (var i = 0; i < readButtons.length; i++) {
            readButtons[i].addEventListener('click', this.handleOpenClick.bind(this));
            readButtons[i].setAttribute('aria-controls', 'app');
            readButtons[i].setAttribute('aria-expanded', 'false');
        }
    }
    handleOpenClick(e) {
        e.preventDefault();
        var isPreview = e.target.getAttribute('data-preview') || 'false';
        var id = e.target.getAttribute('data-id');
        var lang = e.target.getAttribute('data-lang');
        e.target.setAttribute('aria-expanded', 'true');
        if (window.history.pushState) {
            var params = new URLSearchParams(window.location.search);
            params.set('pub', id);
            params.set('lang', lang);
            window.history.pushState(null, null, "?" + params.toString());
        }
        this.open(id, isPreview, lang);
    }
    open(id, isPreview, lang) {
        store.dispatch(fetchPub(this.apiUrl, id, isPreview, lang, () => {
        window.scrollTo(0,0);
        }));
        this.render();
    }
    close() {
        ReactDOM.unmountComponentAtNode(this.container);
        document.getElementById('body').removeAttribute('style');
        window.scrollTo(0, store.getState().scrollPosition);
        var expandedButton = document.querySelector(`${this.readButtonSelector}[aria-expanded='true']`)
        if(expandedButton) {
            expandedButton.setAttribute('aria-expanded', 'false');
        }
    }
    render() {
        ReactDOM.render(
            <Provider store={store}>
                <div className="pubr" id="reader-app">
                    <Overlay>
                        <div id="tab-guard-north" tabIndex="0"></div>
                        <Main />
                        <div id="tab-guard-south" tabIndex="0"></div>
                    </Overlay>
                </div>
            </Provider>,
            this.container,
            () => {
                store.dispatch(initClientSide());
            }
        );
    }
    hydrate() {
        store.dispatch(receivePub(this.preloadedPub));
        store.dispatch(receivedPub());
        ReactDOM.hydrate(
            <Provider store={store}>
                <div className="pubr" id="reader-app">
                    <Overlay>
                        <div id="tab-guard-north" tabIndex="0"></div>
                        <Main />
                        <div id="tab-guard-south" tabIndex="0"></div>
                    </Overlay>
                </div>
            </Provider>,
            this.container,
            () => {
                store.dispatch(initClientSide());
            }
        );      
    }    
}



// WEBPACK FOOTER //
// ./src/client.js